import React from 'react';
import { useProduction } from '../../../hooks/useProduction';
import { ProductionPage } from './ProductionPage';
import ProductionReports from './ProductionReports';
import { FormBase } from '../../Interface';

const ProductionMain = ({ selectedOrderData, items }) => {
  const productionState = useProduction();
  return (
    <FormBase
      name="Production"
      leftPanelContent={<ProductionPage productionState={productionState} items={items} />}
      rightPanelContent={<ProductionReports productionState={productionState} selectedOrderData={selectedOrderData} />}
    />
  );
};

export default ProductionMain;
